

export class PoiDetailsOutputWithStatus implements IPoiDetailsOutputWithStatus {
    /** The auto-generated id of the poi details master */
    poi_details_id!: number;
    /** The place name with 255 character limit */
    place_name!: string;
    /** The combination of lat and long */
    geo_code!: string;
    /** The poi type name with 255 character limit */
    poi_type_name!: string;
    /** The street with 255 character limit */
    street!: string;
    /** The city name with 255 character limit */
    city_name!: string;
    /** The state name with 6 character limit */
    state_name!: string;
    /** Selection on company it will be all or it will be company details id character limit */
    company!: string;
    /** Selection on branch it will be all or it will be branch details id character limit */
    branch!: string;
    /** The status of poi details should be 0 or 1 */
    status!: number;

    constructor(data?: IPoiDetailsOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_details_id = _data["poi_details_id"];
            this.place_name = _data["place_name"];
            this.geo_code = _data["geo_code"];
            this.poi_type_name = _data["poi_type_name"];
            this.street = _data["street"];
            this.city_name = _data["city_name"];
            this.state_name = _data["state_name"];
            this.company = _data["company"];
            this.branch = _data["branch"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiDetailsOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_details_id"] = this.poi_details_id;
        data["place_name"] = this.place_name;
        data["geo_code"] = this.geo_code;
        data["poi_type_name"] = this.poi_type_name;
        data["street"] = this.street;
        data["city_name"] = this.city_name;
        data["state_name"] = this.state_name;
        data["company"] = this.company;
        data["branch"] = this.branch;
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiDetailsOutputWithStatus {
    /** The auto-generated id of the poi details master */
    poi_details_id: number;
    /** The place name with 255 character limit */
    place_name: string;
    /** The combination of lat and long */
    geo_code: string;
    /** The poi type name with 255 character limit */
    poi_type_name: string;
    /** The street with 255 character limit */
    street: string;
    /** The city name with 255 character limit */
    city_name: string;
    /** The state name with 6 character limit */
    state_name: string;
    /** Selection on company it will be all or it will be company details id character limit */
    company: string;
    /** Selection on branch it will be all or it will be branch details id character limit */
    branch: string;
    /** The status of poi details should be 0 or 1 */
    status: number;
}

